import React from 'react';
import { clientContactAccessMatrix, getEffectiveClientContactAccess } from '../../utils/clientContactPermissions';

export default function ContactRolePermissions({ contact, onAccessChange, onAllAccessChange }) {
  const selectedCount = clientContactAccessMatrix.filter(([key]) => getEffectiveClientContactAccess(contact, key) === 'G').length;
  const allChecked = selectedCount === clientContactAccessMatrix.length;
  return (
    <div className="mt-3">
      <label className="mb-3 flex cursor-pointer items-center gap-3 border-b border-violet-200 pb-3 text-sm font-semibold text-slate-900">
        <input type="checkbox" checked={allChecked} ref={(input) => { if (input) input.indeterminate = selectedCount > 0 && !allChecked; }} onChange={(event) => onAllAccessChange(event.target.checked ? 'G' : '—')} className="h-4 w-4 accent-blue-700" />
        Tout cocher
      </label>
    <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
      {clientContactAccessMatrix.map(([key, label]) => {
        const checked = getEffectiveClientContactAccess(contact, key) === 'G';
        return (
          <label key={key} className={`flex cursor-pointer items-center gap-3 rounded-lg border px-3 py-3 text-sm transition-colors ${checked ? 'border-blue-200 bg-blue-50 text-blue-900' : 'border-slate-200 bg-white text-slate-600 hover:border-blue-200'}`}>
            <input type="checkbox" checked={checked} onChange={(event) => onAccessChange(key, event.target.checked ? 'G' : '—')} className="h-4 w-4 shrink-0 accent-blue-700" />
            <span>{label}</span>
          </label>
        );
      })}
    </div>
    </div>
  );
}
